module.exports = __webpack_public_path__ + "static/media/maintainance.4f8b7f0d.png";